import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'small' | 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300/50 transition-all duration-300"
      data-product-shop=""
    >
      <div className="relative overflow-hidden" style={{ width: '100%', aspectRatio: '2/3' }}>
        <img
          src={movie.posterUrl}
          alt={`${movie.title} - 高清电影在线看`}
          title={`${movie.title} 免费在线观看 高清不缓冲`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        {movie.isNew && (
          <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            新上映
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-3 right-3 px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
            热门
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <div className="flex items-center gap-2 text-xs text-background-100/80 mb-1">
            <span>{movie.year}</span>
            <span className="w-1 h-1 rounded-full bg-background-100/40"></span>
            <span>{movie.duration}</span>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-background-50 line-clamp-1">
            {movie.title}
          </h3>
        </div>

        <div className="absolute top-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-xl text-background-50"></i>
          </div>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs text-secondary-500 bg-secondary-100 px-2 py-0.5 rounded-md whitespace-nowrap">
            {movie.category}
          </span>
          <span className="flex items-center gap-1 text-xs text-primary-500">
            <i className="ri-star-fill text-xs"></i>
            {movie.rating}
          </span>
        </div>
        <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
          {movie.description}
        </p>
      </div>
    </Link>
  );
}